import React from "react";
import { animateSpinIcon } from "../../assets/icons/SvgIconList";

const Loader = () => {
  return (
    <div className="fixed top-0 left-0 h-svh w-full z-10 flex justify-center items-center bg-black bg-opacity-50">
      <div className="size-20 text-accent">{animateSpinIcon}</div>
    </div>
  );
};

export default Loader;
